import {Link, useLocation, useNavigate} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {logoUrl} from '../data';

const {FiInstagram, FiFacebook} = FiIcons;

function Footer() {
  const location = useLocation();
  const navigate = useNavigate();

  const visitSection = (sectionId) => {
    if (location.pathname === '/') {
      document.getElementById(sectionId)?.scrollIntoView({behavior: 'smooth'});
      return;
    }
    navigate('/', {state: {scrollTo: sectionId}});
  };

  return (
    <footer className="footer">
      <div className="footer-grid">
        <div className="footer-brand">
          <img src={logoUrl} alt="ZEVI" />
          <p>Elegance that Never Fades</p>
          <span>Sri Lanka | Luxury Sarees For Every Story</span>
        </div>
        <div className="footer-column">
          <h3>Navigation</h3>
          <button onClick={() => visitSection('home')}>Home</button>
          <button onClick={() => visitSection('collection')}>Collection</button>
          <button onClick={() => visitSection('about')}>About</button>
          <button onClick={() => visitSection('contact')}>Contact</button>
        </div>
        <div className="footer-column">
          <h3>Customer</h3>
          <Link to="/cart">My Cart</Link>
          <Link to="/checkout">Checkout</Link>
          <Link to="/order-tracking">Order Tracking</Link>
          <span>Delivery Information</span>
          <span>Payment Options</span>
          <span>Returns and Refunds</span>
        </div>
        <div className="footer-column">
          <h3>Contact</h3>
          <a href="tel:0770729637">077 072 9637</a>
          <a href="tel:+97339581410">+973 3958 1410</a>
          <a href="mailto:info@zevilanka.com">info@zevilanka.com</a>
          <span>Colombo, Sri Lanka</span>
          <div className="footer-socials">
            <span title="Instagram profile not configured" aria-label="Instagram profile not configured">
              <SafeIcon icon={FiInstagram} />
            </span>
            <span title="Facebook profile not configured" aria-label="Facebook profile not configured">
              <SafeIcon icon={FiFacebook} />
            </span>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <span>© 2026 ZEVI. All Rights Reserved.</span>
        <span>Sri Lanka | Luxury Sarees For Every Story</span>
      </div>
    </footer>
  );
}

export default Footer;